function genAuthKey(secretSeed = "") {
  const now = Math.floor(Date.now() / 1000);
  const timeWindow = Math.floor(now / 30);  
  function seedRandom(seed) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) {
      h = Math.imul(31, h) + seed.charCodeAt(i) | 0;
    }
    return function() {
      h = Math.imul(h, 0x41c64e6d) + 0x3039;
      return (h >>> 0) / 0x100000000;
    };
  }
  
  const baseRng = seedRandom(`${secretSeed}-${timeWindow}`);
  
  const minuteNoise = Math.floor((now % 3600) / 60);
  const noiseRng = seedRandom(`${secretSeed}-noise-${minuteNoise}`);
  
  const components = [];
  for (let i = 0; i < 4; i++) {
    const base = Math.floor(baseRng() * 256);
    const noise = Math.floor(noiseRng() * 32) - 16; 
    const position = (i * 37) % 256; 
    
    let value = (base + noise + position) % 256;
    if (value < 0) value += 256;
    
    components.push(value.toString(16).padStart(2, '0'));
  }
  
  const checksum = components.reduce((acc, comp) => 
    acc ^ parseInt(comp, 16), timeWindow & 0xFF
  );
  
  components.push(checksum.toString(16).padStart(2, '0'));
  
  const encodedTime = ((timeWindow ^ 0xDEADBEEF) >>> 0).toString(16).padStart(8, '0');
  
  return `${encodedTime}-${components.join('')}`;
}


async function getKey() {
  let key;
  key = sessionStorage.getItem("ReportingKey")
  if (key) return key 
  try {
    let response = await fetch("https://apiapi.ombligo.com/er", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    key = await response.json();
    return key;
  } catch (error) {
    console.error('Error fetching today\'s key:', error);
    throw error; 
  }
}

async function postER(key, error){
    let data = JSON.stringify({
        "secret": key,
        "error":error
    });
    let endpoint = "https://apiapi.ombligo.com/er";
    if (navigator.sendBeacon) {
        const blob = new Blob([data], { type: 'application/json' });
        
        try {
            const success = navigator.sendBeacon(endpoint, blob);
            if (success) {
                console.log("beacon")
            } else {
                console.warn('Reporting beacon failed to queue');
            }
            return success;
        } catch (error) {
            console.error('Error sending reporting beacon:', error);
            return false;
        }
    } else {
        let response = await fetch(endpoint, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body:data
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        let resp = await response.json();
        console.log(resp);
        return resp;
    }

}

async function reportE(error){
  let key = await getKey();
  let pKey ;
  if (key){
    pKey = genAuthKey(key)
    await postER(pKey, error)
  }

}